import { isMobile } from 'react-device-detect';
import { useWorkerStore } from '@worker/stores';
import { Stack, Paper, Text, Divider } from '@mantine/core';
import { useMemo } from 'react';
import {
  useWorkerAvailability,
  useDeleteWorkerAvailability,
} from '@worker/hooks/useWorkerData';
import { transformWorkerAvailabilityToEntries } from '@worker/helpers/my-jobs-helpers';
import AvailabilityList from './AvailabilityList';
import AvailabilityForm from './AvailabilityForm';

export default function Availability() {
  const { workerProfile } = useWorkerStore();
  const { data: workerAvailabilityData, isLoading } = useWorkerAvailability();
  const deleteAvailabilityMutation = useDeleteWorkerAvailability();

  const allEntries = useMemo(() => {
    const timezoneId = workerProfile?.workerProfile?.address?.timezoneId;
    return workerAvailabilityData?.workerAvailabilities
      ? transformWorkerAvailabilityToEntries(
          workerAvailabilityData.workerAvailabilities,
          timezoneId
        )
      : [];
  }, [
    workerAvailabilityData?.workerAvailabilities,
    workerProfile?.workerProfile?.address?.timezoneId,
  ]);

  const handleDelete = (id: string) => {
    deleteAvailabilityMutation.mutate(Number(id));
  };

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Add days off on your schedule and company&apos;s will see it on your
        availability calendar.
      </Text>
      {isMobile ? (
        <AvailabilityForm />
      ) : (
        <Paper p="xs" withBorder shadow="xs" radius="md">
          <AvailabilityForm />
        </Paper>
      )}
      <Divider my={0} />
      <AvailabilityList
        entries={allEntries}
        onDelete={handleDelete}
        isLoading={isLoading}
      />
    </Stack>
  );
}
